import React, {useMemo} from 'react'
import {BoxLink} from '../../common/router_links/BoxLink'
import {useBoxesByFailedOpeningsLast2WeeksQuery} from '../../generated/graphql'
import {Box} from '../../webui/Box'
import {LoadingSpinnerContainer} from '../../webui/progress/LoadingSpinnerContainer'
import {SortablePaginatedTable} from '../../webui/table/sortable-paginated-table/SortablePaginatedTable'
import {TableHeadCell} from '../../webui/table/sortable-paginated-table/TableHeadCell'
import {Typography} from '../../webui/Typography'

interface Props {}

interface FailedOpeningBoxRow {
  id: string
  boxName: string
  count: number
}

const tableHeadCells: TableHeadCell<FailedOpeningBoxRow>[] = [
  {
    id: 'boxName',
    label: 'Box',
    render: (row) => <BoxLink boxId={row.id} linkText={row.boxName} />,
  },
  {
    id: 'count',
    label: 'Failed openings (last 2 weeks)',
    render: (row) => row.count,
  },
]

export const FailedOpeningsTable: React.FC<Props> = () => {
  const {data, loading, error} = useBoxesByFailedOpeningsLast2WeeksQuery()

  const rows: FailedOpeningBoxRow[] = useMemo(
    () =>
      data?.failedOpening?.boxesByFailedOpeningsLast2Weeks.map((box) => ({
        id: box.id,
        boxName: box.name,
        count: box.count,
      })) ?? [],
    [data],
  )

  if (loading) {
    return <LoadingSpinnerContainer />
  }

  if (error) {
    return <div>{error.message}</div>
  }

  if (rows.length === 0) {
    return (
      <Box pt={1}>
        <Typography>No failed openings in the last 2 weeks</Typography>
      </Box>
    )
  }

  return (
    <SortablePaginatedTable
      initialOrderByKey={'count'}
      initialOrder={'desc'}
      initialRowsPerPage={10}
      rows={rows}
      tableHeadCells={tableHeadCells}
      contentAlign="left"
      searchEnabled={false}
    />
  )
}
